import {ICARequest} from "./ICARequest";
import {TabMetrics} from "./TabMetrics";

export interface IRequestsWithMetrics {
    requests: ICARequest[];
    tabMetrics: TabMetrics;
}

export class RequestsWithMetrics implements IRequestsWithMetrics {
    requests: ICARequest[];
    tabMetrics: TabMetrics;

    constructor() {
        this.requests = [];
        this.tabMetrics = new TabMetrics();
    }
}